<template>
  <div class="pa-3" id="topics">
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">
              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
              <div style="text-align:center; margin:3rem 0 -1rem; color:#C62828">当社のプライバシーポリシーに関する質問やお問い合わせがある場合には以下にご連絡ください。</div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '',
      // タイトル横のアイコン
      icon: '',
      contents: [
        {
          // 説明タイトル
          descriptiontitle: '1.個人情報の定義',
          // 説明文
          description: `
本プライバシーポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）を意味するものとします。`
        },
        {
          // 説明タイトル2
          descriptiontitle: '2.個人情報の取得・利用・提供',
          // 説明文2
          description: `
当社は、事業の内容および規模を考慮した適切な個人情報の取得、利用および提供について、特定された利用目的の達成に必要な範囲内に限定し適切に取扱います。`
        },
        {
          // 説明タイトル3
          descriptiontitle: '3.個人情報利用の制限',
          // 説明文3
          description: `
当社は、個人情報保護法その他の法令により許容される場合を除き、お客様の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
1.法令に基づく場合
2.人の生命、身体又は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき
3.国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき`
        },
        {
          // 説明タイトル4
          descriptiontitle: '4.個人情報の安全管理',
          // 説明文4
          description: `
当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。
また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。`
        },
        {
          // 説明タイトル5
          descriptiontitle: '5.個人情報関連の法令について',
          // 説明文5
          description: `
個人情報に関する法令及びその他の規範を遵守いたします。`
        },
        {
          // 説明タイトル6
          descriptiontitle: '6.Google Analyticsについて',
          // 説明文6
          description: `
当サイトでは、お客様の本サイトの訪問状況を把握するためにGoogle 社のサービスであるGoogle Analyticsを利用しています。
Google Analyticsは、インターネットの標準的なログ情報や訪問者の行動を匿名形式で収集するために、「クッキー」と呼ばれるコンピュータ上のテキストファイルを使用しています。
Google Analyticsにより収集、記録、分析されたお客様の情報には、特定の個人を識別する情報は一切含まれません。また、それらの情報は、Google社により同社のプライバシーポリシーに基づいて管理されます。
Google Analyticsによる情報収集を拒否したい場合は、Google アナリティクス オプトアウト アドオンを使用してください。
Google社によるオプトアウトアドオンのダウンロードページ`
        },
        {
          // 説明タイトル7
          descriptiontitle: '7.本方針の変更',
          // 説明文7
          description: `
当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを変更することがあります。
変更後の本方針については、当サイトに掲載した時から効力を生じるものとします。`
        }
      ]
    }
  }
}
</script>
